const cvModal = {
  state: { show: false, data: {}, userId: null, userData: {} },
  reducers: {
    toggleCVModal(state) {
      return { ...state, show: !state.show };
    },

    setCVModalData(state, payload) {
      return { ...state, data: payload.data };
    },
    setUserCVModalData(state, payload) {
      return { ...state, userData: payload.userData };
    },
  },
  effects: () => ({}),
};
export default cvModal;
